/* eslint-disable */
export const SubTabsConfig = {
	issued: [
		{
			id: 1,
			value: 'ingQuantity',
			header: 'Ingredient Quantity',
		},
		{
			id: 2,
			value: 'startTime',
			header: 'Start/End Time',
		},
		{
			id: 3,
			value: 'duration',
			header: 'Duration',
		},
	],
	// ISSUED: [
	// 	{
	// 		id: 1,
	// 		value: 'orderQty',
	// 		header: 'Qty',
	// 	},
	// 	{
	// 		id: 2,
	// 		value: 'ingQuantity',
	// 		header: 'Ingredient Quantity',
	// 	},
	// 	{
	// 		id: 3,
	// 		value: 'fullfilmentPercentage',
	// 		header: 'Fullfilment %',
	// 	},
	// 	{
	// 		id: 4,
	// 		value: 'containerCount',
	// 		header: 'Cambro Count',
	// 	},
	// 	{
	// 		id: 5,
	// 		value: 'containerUtilization',
	// 		header: 'Cambro Utilization',
	// 	},
	// 	{
	// 		id: 6,
	// 		value: 'fillTime',
	// 		header: 'Fill Time',
	// 	},
	// 	{
	// 		id: 7,
	// 		value: 'temperature',
	// 		header: 'Temperature',
	// 	},
	// 	{
	// 		id: 8,
	// 		value: 'ingTemp',
	// 		header: 'Ingredient Temprature',
	// 	},
	// ],
	produced: [
		{
			id: 1,
			value: 'ingQuantity',
			header: 'Packaged Quantity',
		},
		// {
		// 	id: 2,
		// 	value: 'dispatchedQty',
		// 	header: 'Dispatched Quantity',
		// },
		// {
		// 	id: 3,
		// 	value: 'receivedQty',
		// 	header: 'Received Quantity',
		// },
		// {
		// 	id: 4,
		// 	value: 'containerCount',
		// 	header: 'Cambro Count',
		// },
		// {
		// 	id: 5,
		// 	value: 'containerUtilization',
		// 	header: 'Cambro Utilization',
		// },
	],
	dispatched: [
		{
			id: 2,
			value: 'dispatchedQty',
			header: 'Dispatched Quantity',
		},
		{
			id: 3,
			value: 'receivedQty',
			header: 'Received Quantity',
		},
		// {
		// 	id: 4,
		// 	value: 'containerCount',
		// 	header: 'Cambro Count',
		// },
		// {
		// 	id: 5,
		// 	value: 'containerUtilization',
		// 	header: 'Cambro Utilization',
		// },
	],
	indent: [
		{
			id: 1,
			value: 'dispatchedQty',
			header: 'Dispatched Quantity',
		},
		{
			id: 2,
			value: 'leftOverQty',
			header: 'Left Over Quantity',
		},
		{
			id: 3,
			value: 'consumedQty',
			header: 'Consumed Quantity',
		},
	],
};
